import mainService from "./mainService";
const path = "countries";


export function list() {
    return mainService
        .get(path + "/list/")
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}



// WEBPACK FOOTER //
// ./src/services/country.jsx